import getBusinessUnits from 'FormsUI/api/BusinessUnits/getBusinessUnits';

// @ts-expect-error untyped dependency
import { getBusinessUnitsRequestState } from 'FormsUI/selectors/BusinessUnits';
import { hasBusinessUnitAccess as hasBusinessUnitAccessFromSelector } from 'FormsUI/selectors/Scope';
function createAction(name) {
  return `@@businessUnits/${name}`;
}
export const REQUEST_BUSINESS_UNITS = createAction('REQUEST_BUSINESS_UNITS');
export const RECEIVE_BUSINESS_UNITS = createAction('RECEIVE_BUSINESS_UNITS');
export const SUCCEED_GETTING_BUSINESS_UNITS = createAction('SUCCEED_GETTING_BUSINESS_UNITS');
export const FAILED_GETTING_BUSINESS_UNITS = createAction('FAILED_GETTING_BUSINESS_UNITS');
export function requestBusinessUnits() {
  return {
    type: REQUEST_BUSINESS_UNITS
  };
}
export function receiveBusinessUnits(payload) {
  return {
    type: RECEIVE_BUSINESS_UNITS,
    businessUnits: payload
  };
}
export function succeedGettingBusinessUnits() {
  return {
    type: SUCCEED_GETTING_BUSINESS_UNITS
  };
}
export function failGettingBusinessUnits() {
  return {
    type: FAILED_GETTING_BUSINESS_UNITS
  };
}
export function fetchBusinessUnits() {
  return (dispatch, getState) => {
    const state = getState();
    const requestState = getBusinessUnitsRequestState(state);
    const hasBusinessUnitAccess = hasBusinessUnitAccessFromSelector(state);
    if (hasBusinessUnitAccess && requestState && requestState.shouldBeRequested()) {
      dispatch(requestBusinessUnits());
      getBusinessUnits().then(payload => {
        dispatch(succeedGettingBusinessUnits());
        dispatch(receiveBusinessUnits(payload));
      }).catch(() => {
        dispatch(failGettingBusinessUnits());
      });
      return undefined;
    }
    return false;
  };
}